import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Modal, type ModalProps } from '@udemy-v2/react-dialog-components';
import { CoursePreview } from './course-preview.react-component';
import styles from '@/features/course-landing-page/components/course-preview-entry-point/course-preview-entry-point.module.scss';
import { ColorScheme } from '@udemy-v2/styles';
interface CoursePreviewModalProps {
  onClose: ModalProps['onClose'];
  isOpen: ModalProps['isOpen'];
  uiRegion: string;
  selectedLectureId?: string;
}
export const CoursePreviewModal = t0 => {
  const $ = _c(7);
  const {
    onClose,
    isOpen,
    uiRegion,
    selectedLectureId
  } = t0;
  let t1;
  if ($[0] !== selectedLectureId || $[1] !== uiRegion) {
    t1 = <CoursePreview uiRegion={uiRegion} selectedLectureId={selectedLectureId} />;
    $[0] = selectedLectureId;
    $[1] = uiRegion;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isOpen || $[4] !== onClose || $[5] !== t1) {
    t2 = <ColorScheme colorScheme="dark" className={styles.wrapper}><Modal renderTitle={_temp} title="" isOpen={isOpen} onClose={onClose}>{t1}</Modal></ColorScheme>;
    $[3] = isOpen;
    $[4] = onClose;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function _temp() {
  return ["title-in-body-modal-title", null];
}